import { render } from "./dangjDetail.vue?vue&type=template&id=4ea999b0&scoped=true"
import script from "./dangjDetail.vue?vue&type=script&lang=js"
export * from "./dangjDetail.vue?vue&type=script&lang=js"

import "./dangjDetail.vue?vue&type=style&index=0&id=4ea999b0&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ea999b0"]])

export default __exports__